module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Storylava","short_name":"Storylava","start_url":"/","background_color":"#0078ca","theme_color":"#0078ca","display":"standalone","icon":"src/images/storylava-icon.png","crossOrigin":"use-credentials","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","include_favicon":true,"cacheDigest":"94e2fa4d168bfb84fb5080e152d210e0"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
